import type { IAuthSDK } from '../base-client/AuthSDK';
import { MMBaseClient } from '../base-client/MMBaseClient';
import { KEGatewayConfig } from './config';
import type { Options } from 'ky';
import { getInstallId } from '#shared/helpers/getInstallId';

export class KEGatewayClient extends MMBaseClient {
  constructor(authSDK?: IAuthSDK) {
    super(KEGatewayConfig.getBaseUrl(), authSDK);

    this.kyInstance = this.kyInstance.extend((options: Options) => ({
      headers: {
        ...options.headers,
        'x-iid': getInstallId(),
      },
    }));
  }
}
